import {QueryClient} from '@tanstack/react-query';

// This is a singleton to store the QueryClient reference
// It avoids React context issues in monorepos
let globalQueryClient: unknown = null;

/**
 * Set the global QueryClient reference from the main application
 * Call this as early as possible in your application startup
 */
export const setQueryClient = (client: unknown): void => {
  globalQueryClient = client;
};

/**
 * Get the global QueryClient reference
 * This is used by shared hooks when React context fails
 */
export const getQueryClient = (): QueryClient => {
  if (!globalQueryClient) {
    // Create a temporary client if none exists
    // This avoids breaking errors but won't persist data between calls
    globalQueryClient = new QueryClient({
      defaultOptions: {
        queries: {
          retry: false,
          refetchOnWindowFocus: false,
        },
      },
    });

    console.warn(
      'No QueryClient was explicitly set with setQueryClient(). ' +
        'Using a temporary client that will not persist data. ' +
        'Call setQueryClient() with your application QueryClient instance as early as possible.'
    );
  }

  return globalQueryClient as QueryClient;
};
